import type { SVGProps } from 'react';
const SvgPaperclip2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.286 15.946V4.714a3.304 3.304 0 0 0-3.304-3.303H8.018a3.304 3.304 0 0 0-3.304 3.303v11.232a2.643 2.643 0 0 0 2.643 2.643H9.34a2.643 2.643 0 0 0 2.643-2.643v-9.91a1.32 1.32 0 0 0-1.321-1.322H9.339a1.32 1.32 0 0 0-1.321 1.322v7.268"
    />
  </svg>
);
export default SvgPaperclip2;
